import React, { createContext, useContext, useState, ReactNode } from 'react';
import { SubCategoryInterface } from '../assets/interfaces/FX_POS_Interfaces';

interface SubCatPropsData {
  selectedSubCategory: SubCategoryInterface | null;
  setSelectedSubCategory: (sub_cat: SubCategoryInterface | null) => void;
}

const SubCategoryContext = createContext<SubCatPropsData | undefined>(undefined);

export const useSubCategory = () => {
  const context = useContext(SubCategoryContext);
  if (context === undefined) {
    throw new Error('useSubCategory must be used within a SubCategoryProvider');
  }
  return context;
};

interface SubCategoryProviderProps {
  children: ReactNode;
}

export const SubCategoryProvider: React.FC<SubCategoryProviderProps> = ({ children }) => {
  const [selectedSubCategory, setSelectedSubCategory] = useState<SubCategoryInterface | null>(null);

  return (
    <SubCategoryContext.Provider value={{ selectedSubCategory, setSelectedSubCategory }}>
      {children}
    </SubCategoryContext.Provider>
  );
};
